/**
 * Note: page views are tracked by `gatsby-plugin-posthog`
 * onRouteUpdate: https://github.com/PostHog/gatsby-plugin-posthog/blob/main/src/gatsby-browser.js
 */
export function capture(event: string, properties?: Record<string, any>) {
  if (!window?.posthog) return
  window?.posthog?.capture(event, properties)
}

export function identify(id: string) {
  if (!window?.posthog) return
  window?.posthog?.identify(id)
}

export function reset(resetDeviceId?: boolean) {
  if (!window?.posthog) return
  window?.posthog?.reset(resetDeviceId)
}
